import { ASSETS } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function MeetJoanne() {
  return (
    <section
      data-testid="meet-joanne"
      className="relative py-24 md:py-40 bg-muted/60"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <Overline>Meet Joanne</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl font-light leading-tight tracking-tight">
              Leadership begins at home.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg leading-relaxed text-muted-foreground max-w-md">
              Behavioral science was never meant to stay inside the clinic. It
              belongs wherever people are learning, leading, building, and creating
              change.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal delay={0.1}>
            <div className="relative overflow-hidden rounded-2xl aspect-[2/1] bg-secondary">
              <img
                data-testid="meet-joanne-image"
                src={ASSETS.meetFamily}
                alt="Dr. Joanne Hill Powell with her husband and children"
                className="w-full h-full object-cover"
                style={{
                  objectPosition: "50% 74%",
                  transform: "scale(1.12)",
                  transformOrigin: "50% 80%",
                }}
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
